import { Serializer } from "../serializer"
import { AnalyticsEvent, AnalyticsItem } from "./analytics"

export class AnalyticsEventSerializer implements Serializer {
  fromJson(json: any) {
    const event = new AnalyticsEvent()
    event.id = json.id
    event.name = json.name
    event.eventId = json.event_id
    event.pagePath = json.page_path
    event.pageTitle = json.page_title
    event.searchTerm = json.search_term
    event.method = json.method
    event.currency = json.currency
    event.value = json.value
    event.transactionId = json.transaction_id
    event.coupon = json.coupon
    event.shipping = json.shipping
    event.tax = json.tax
    event.items = json.items || []
    event.params = json.params || {}
    event.clientId = json.client_id
    return event
  }

  toJson(event: AnalyticsEvent) {
    return {
      name: event.name,
      event_id: event.eventId,
      page_path: event.pagePath,
      page_title: event.pageTitle,
      search_term: event.searchTerm,
      method: event.method,
      currency: event.currency,
      value: event.value,
      transaction_id: event.transactionId,
      coupon: event.coupon,
      shipping: event.shipping,
      tax: event.tax,
      items: event.items,
      params: event.params,
      client_id: event.clientId,
    }
  }
}

export const analyticsEventSerializer = new AnalyticsEventSerializer()
